import { message } from 'antd';
import { fetchData } from '../middleware/fetchData';
// 微信授权
export function wxAuthorize ({ companyId, scene, businessId, appId, platformAppId, fixDomain }) {
    // 跳转微信授权
    const params = {
        companyId,
        scene,
        businessId,
        courseUrl: window.location.protocol + '//' + fixDomain + window.location.pathname + window.location.search + `&appId=${appId}`
    };
    console.log('wxAuthorize:', params);
    fetchData('/scrm-base/pass/queryDomain', {
        body: JSON.stringify(params)
    }).then((res) => {
        if (res && res.code === 200 && res.data) {
            const { wechatAuthDomain, wechatType, wechatSeq } = res.data;
            let wxplatform = `https://${wechatAuthDomain}/pro5/index.html`;
            let backendUrl = `&response_type=code&scope=snsapi_userinfo&state=STATE&component_appid=${platformAppId}#wechat_redirect`;
            if (wechatType === 'SELF') {
                backendUrl = `&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
            }
            const url = encodeURIComponent(`${wxplatform}?wechatSeq=${wechatSeq}&env=${process.env.Text}&companyId=${companyId}`);
            console.log('redirect_uri=', url);
            window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${url}${backendUrl}`)
        } else {
            message.error('获取授权域名失败');
        }
    });
}